import { createFileRoute } from "@tanstack/react-router";
import { LicenseGroupPage } from "@/pages/license-group/license-group-page.tsx";

export const Route = createFileRoute("/_auth/_isAdmin/einstellungen/entra/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <LicenseGroupPage />;
}
